angular.module('storefrontApp')
    .component('vcResetPassword', {
        templateUrl: 'themes/assets/js/common-components/account-reset-password.tpl.liquid',
        controller: ['rsAccountService', function (accountService) {
            const ctrl = this;

            ctrl.setForm = function (form) {
                ctrl.form = form;
            };

            ctrl.submit = function () {
                if (ctrl.form.$invalid) {
                    return false;
                }

                accountService.resetPassword({ Email: ctrl.email })
                    .then(function (result) {
                        angular.extend(ctrl, result.data);
                    });

                return true;
            };
        }],

    });
